import { api } from "./api";

export type AppNotification = {
  id: string;
  type: string;
  title: string;
  body: string;
  linkUrl: string | null;
  isRead: boolean;
  createdAt: string;
};

export function listNotifications(unreadOnly = false): Promise<AppNotification[]> {
  return api<AppNotification[]>(`/notifications${unreadOnly ? "?unreadOnly=true" : ""}`);
}

export function getUnreadCount(): Promise<{ count: number }> {
  return api<{ count: number }>("/notifications/unread-count");
}

export function markNotificationRead(id: string): Promise<void> {
  return api<void>(`/notifications/${id}/read`, { method: "POST" });
}

export function markAllNotificationsRead(): Promise<void> {
  return api<void>("/notifications/read-all", { method: "POST" });
}
